module.exports = {
  Others: 'อื่นๆ',
  YouToViewOrFiles: 'คุณไม่มีสิทธิ์ดูหรือพิมพ์ไฟล์ที่ผู้อื่นอัปโหลด',
  BookingAgent: 'ตัวแทนการจองพื้นที่',
  BasicInformation: 'ข้อมูลพื้นฐาน',
  FileHistory: 'ประวัติไฟล์',
  Cancel: 'ยกเลิก',
  Save: 'บันทึก',
  SynchronizeFees: 'ค่าธรรมเนียมการซิงค์',
  ProjectNameCannotBeEmpty: 'ชื่อโครงการไม่สามารถเว้นว่างได้!',
  CustomerNameCannotBeEmpty: 'ชื่อลูกค้าไม่สามารถเว้นว่างได้!',
  ProjectCycleCannotBeEmpty: 'ระยะเวลาโครงการไม่สามารถเว้นว่างได้!',
  EndBeEarlierThanDate: 'วันที่สิ้นสุดไม่สามารถเร็วกว่าวันที่เริ่มต้นได้!',
  AccountingCurrencyCannotBeEmpty: 'สกุลเงินการคำนวณไม่สามารถเว้นว่างได้!',
  ProjectManagerCannotBeEmpty: 'ผู้จัดการโครงการไม่สามารถเว้นว่างได้!',
  ProjectDepartmentCannotBeEmpty: 'แผนกโครงการไม่สามารถเว้นว่างได้!',
  ProjectCompanyCannotBeEmpty: 'บริษัทโครงการไม่สามารถเว้นว่างได้!',
  SaveSuccessfully: 'บันทึกสำเร็จ',
  TheStatusCannotBeEdited: 'สถานะโครงการปัจจุบันไม่สามารถแก้ไขได้!',
  TheStatusCannotBeDeleted: 'สถานะโครงการปัจจุบันไม่สามารถลบได้',
  PleaseToDeleteTheNumber: 'กรุณายืนยันการลบหมายเลข',
  Prompt: 'แจ้งเตือน',
  Confirm: 'ยืนยัน',
  DeleteSuccessfully: 'ลบสำเร็จ',
  CancelledDeletion: 'ยกเลิกการลบแล้ว',
  ProjectStatusCompleted: 'สถานะโครงการเสร็จสมบูรณ์',
  PleaseCanCloseTheNumber: 'กรุณายืนยันการปิดหมายเลข',
  ClosedSuccessfully: 'ปิดสำเร็จ',
  ClosedCancelled: 'ยกเลิกการปิดแล้ว',
  ProjectStatusInProgress: 'สถานะโครงการกำลังดำเนินการ',
  PleaseNeedToReopenNumber: 'กรุณายืนยันการเปิดหมายเลขใหม่',
  SuccessfullyOpened: 'เปิดสำเร็จ',
  CancelledOpening: 'ยกเลิกการเปิดแล้ว',
  PleaseSelectARecord: 'กรุณาเลือกหนึ่งรายการ!',
  DeletedSuccessfully: 'ลบสำเร็จ',
  DeletionCancelled: 'ยกเลิกการลบแล้ว',
  CancelledClosing: 'ยกเลิกการปิดแล้ว',
  OpenedSuccessfully: 'เปิดสำเร็จ',
  XNotAllowViewOrDownload: 'ไฟล์ {0} ไม่อนุญาตให้ดูหรือดาวน์โหลด',
  NoPermissionView: 'คุณไม่มีสิทธิ์ดูหรือดาวน์โหลดไฟล์ {0}',
  PleaseToDeleteTheProject: 'กรุณายืนยันการลบโครงการหมายเลข {0}'
}
